exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-indicator{border-radius:2px;background-color:#9b9b9b;min-height:1px}.loading-indicator .progress-indicator{border-radius:2px;background-color:#184e78;min-height:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ProgressIndicator/ProgressIndicator.scss
// module id = 1601
// module chunks = 0